"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgClockPlus = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11c0 .583-.045 1.155-.133 1.714-.073.465-.109.697-.201.805a.415.415 0 0 1-.317.171c-.14.018-.463-.129-1.108-.422a3 3 0 0 0-6.973 6.973c.293.645.44.967.422 1.108a.415.415 0 0 1-.17.317c-.109.092-.341.128-.806.201-.559.088-1.131.133-1.714.133-6.075 0-11-4.925-11-11Zm12-6a1 1 0 1 0-2 0v6a1 1 0 0 0 .553.894l4 2a1 1 0 1 0 .894-1.788L13 11.382V6Z", fill: "currentColor" }), (0, jsx_runtime_1.jsx)("path", { d: "M21 17a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2Z", fill: "currentColor" })] }))); };
exports.default = SvgClockPlus;
